
import { useCallback} from 'react';
import { useContext, useState } from 'react';

import { HimmaContext } from "../Context/HimmaContext";

import {
  DeleteSubAdminsRequest,
  ToggleSubAdminStatusRequest,
} from '.././client-sdk/api';

const userData = JSON.parse(localStorage.getItem('userData') || '{}');
const localStorageStoreId = userData?.userDetails?.storeId 

export const useItemSubCategoryApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  //   const createSubAdmin = useCallback(
  //     async (subAdminData: AddOrEditSubAdminRequest) => {
  //       setLoading(true);
  //       setError(null);
  //       try {
  //         const response = await subAdminApi.createSubAdminUser(subAdminData);
  //         return response.data;
  //       } catch (err) {
  //         setError(err instanceof Error ? err.message : "An error occurred");
  //         throw err;
  //       } finally {
  //         setLoading(false);
  //       }
  //     },
  //     [subAdminApi]
  //   );

  const getAllItemSubCategory = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.getSubItemCategories(
          query.categoryId,
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          query.statusFilter,
          query.addedByFilter,
          query.search,
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleItemCategoriesStatus(
          toggleSubAdminStatusRequest,localStorageStoreId
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteItemSubCategory = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteSubAdmins: DeleteSubAdminsRequest = {
          ids: [query],
        };

        const response = await api.deleteSubItemCategory(deleteSubAdmins,localStorageStoreId);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  //   const editSubAdmin = useCallback(
  //     async (id: any, subAdminData: AddOrEditSubAdminRequest) => {
  //       setLoading(true);
  //       setError(null);
  //       try {
  //         const response = await subAdminApi.editSubAdmin(id, subAdminData);
  //         return response.data;
  //       } catch (err) {
  //         setError(err instanceof Error ? err.message : "An error occurred");
  //         throw err;
  //       } finally {
  //         setLoading(false);
  //       }
  //     },
  //     [subAdminApi]
  //   );
  return {
    getAllItemSubCategory,
    loading,
    error,
    getToggleStatus,
    deleteItemSubCategory,
    // deleteSubAdmin,
    // editSubAdmin,
  };
};
